
import React, { ChangeEvent, useState, useEffect } from 'react';
export default function FileUploadControl(props) {
    const [filename, setFileName] = useState('');
    const [filesize, setFileSize] = useState('');
    const [filetype, setFileType] = useState('');
    const [file_image, setfile_image] = useState('');
    const filesizes = (bytes, decimals = 2) => {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }
    const filesType = (valueType,valueName) => {
        if (valueType === "") {
            let ABC = valueName.split('.');            
            return ABC[1];
        }
        else {
            return valueType;
        }
    }
    const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.files) {
            //console.log("e.target.files[0]:::",e.target.files[0]);
            setFileName(e.target.files[0].name);
            setFileSize(filesizes(e.target.files[0].size));
            setFileType(filesType(e.target.files[0].type, e.target.files[0].name));
            let file = e.target.files[0];
            let reader = new FileReader();
            reader.onloadend = () => {
                props.onChange((preValue) => {
                    {
                        setfile_image(reader.result);
                        return [{
                            file_name: e.target.files[0].name,
                            file_type: filesType(e.target.files[0].type, e.target.files[0].name),
                            file_size: filesizes(e.target.files[0].size),
                            file_image: reader.result,


                        }]
                    }

                });
            }
            if (e.target.files[0]) {
                reader.readAsDataURL(file);
            }

        }
    };
    const DeleteFile = () => {
        setFileName("");
        setFileSize("");
        setFileType("");
        setfile_image("");
        props.onChange("");
    }

    useEffect(() => {
        try {
            if (props.value !== undefined && props.value !== '') {
                let A = JSON.parse(props.value);

                setFileName(A[0].file_name !== undefined ? A[0].file_name : "");
                setFileSize(A[0].file_size !== undefined ? A[0].file_size : "");
                setFileType(A[0].file_type !== undefined ? A[0].file_type : "");
                setfile_image(A[0].file_image !== undefined ? A[0].file_image : "");
            }
        }
        catch{ }

    }, [props.value])
    return (
        <div className="form-control ">
            <label htmlFor={props.id} style={{ marginTop: "-11px" }}>
                <i className="icon ion-ios-cloud-download-outline" style={{ fontSize: "35px", color: "rgb(37, 155, 183)" }}></i>
            </label>
            {filename !== "" && <div style={{ fontSize: "16px" }} className="pull-left form-group">
                <span style={{ color: "#685252", marginLeft: "10px" }}>نام فایل</span>
                <span style={{ color: "rgb(29, 142, 168)", marginLeft: "20px" }}>{filename}</span>
                <span style={{ color: "#685252", marginLeft: "0px" }}>حجم فایل:</span>
                <span style={{ color: "rgb(29, 142, 168)", marginLeft: "20px" }}>{filesize} بایت</span>
                <span style={{ color: "#685252", marginLeft: "10px" }}>نوع فایل: </span>
                <span style={{ color: "rgb(29, 142, 168)", marginLeft: "10px" }}>{filetype} </span>
                <img src={filetype.indexOf("image") === -1 ? "img/nopic.jpg" : file_image} style={{ width: "48px", height: "38px", marginTop: "-9px", marginLeft: "35px", borderRadius: "24px" }} />
                <i className="icon ion-android-remove-circle" style={{ fontSize: "20px", color: "red", marginLeft: "10px" }} title="حذف فایل انتخاب شده " onClick={() =>DeleteFile()}></i>
            </div>
            }
            <input hidden id={props.id} type="file" onChange={handleFileChange} />
        </div>

    );
}